<template>
  <div class="status-change-roll-class-not-audit-final"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="auditInfo">
      <div class="body"
           v-loading="committing"
           element-loading-text="数据提交中，请稍等...">
        <div class="audit-main">
          <TitleGroup v-if="auditInfo.studentInfo"
                      title="学生信息">
            <el-form size="mini"
                     label-suffix="：">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="姓名">{{auditInfo.studentInfo.trueName}}</el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="班级">{{auditInfo.studentInfo.className}}</el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="学号">{{auditInfo.studentInfo.regNo}}</el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </TitleGroup>
          <el-divider></el-divider>
          <TitleGroup title="转班信息">
            <el-form size="mini"
                     label-width="80px"
                     label-suffix="：">
              <el-form-item label="转入班级">{{auditInfo.targetClassName}}</el-form-item>
              <el-form-item v-if="auditInfo.material"
                            label="申请材料">
                <file-preview :meta-info="auditInfo.material"></file-preview>
              </el-form-item>
            </el-form>
          </TitleGroup>
          <el-divider></el-divider>
          <TitleGroup title="审核信息">
            <el-form size="mini"
                     label-width="80px"
                     label-suffix="：">
              <el-form-item label="审核状态">
                <el-radio-group v-model="auditStatus">
                  <el-radio label="1">审核通过</el-radio>
                  <el-radio label="2">驳回</el-radio>
                </el-radio-group>
              </el-form-item>
              <template v-if="auditStatus">
                <component ref="audit"
                           :is="auditComponent"
                           :apply-id="rowData.id"
                           :audit-info="auditInfo"></component>
              </template>
            </el-form>
          </TitleGroup>
        </div>
      </div>
      <div class="footer">
        <el-button size="mini"
                   type="primary"
                   :disabled="committing"
                   @click="handleApply">提交保存</el-button>
        <el-button size="mini"
                   type="default"
                   @click="handleClose">关闭窗口</el-button>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>审核数据加载失败</div>
        <el-button type="text"
                   @click="loadAuditInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import TitleGroup from '../../../../../../../../../widgets/custom/TitleGroup'
import StatusChangeRollClassNotAuditFinalPass from './pass'
import StatusChangeRollClassNotAuditFinalReject from './reject'
import Hint from '../../../../../../../../../elements/Hint'
export default {
  name: 'StatusChangeRollClassNotAuditFinal',
  inject: ['$grid'],
  components: {
    TitleGroup,
    Hint
  },
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      auditInfo: null,
      auditStatus: '',
      committing: false
    }
  },
  computed: {
    auditComponent () {
      switch (this.auditStatus) {
        case '1':
          return StatusChangeRollClassNotAuditFinalPass
        case '2':
        default:
          return StatusChangeRollClassNotAuditFinalReject
      }
    }
  },
  methods: {
    loadAuditInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/status/change/auditRollClass/final/auditInfo',
        method: 'post',
        data: this.$qs.stringify({
          postId: this.rowData.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.auditInfo = response.data['auditInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    handleApply () {
      if (!this.auditStatus) {
        this.$message.warning('请选择审核状态')
        return
      }
      let audit = this.$refs.audit
      if (audit) {
        audit.getAuditInfo().then(result => {
          this.committing = true
          this.$ajax(this.$extend(result, {
            method: 'post'
          })).then(response => {
            if (response.data) {
              switch (response.data['responseCode']) {
                case 'SUCCESS': {
                  this.$message.success(response.data['message'])
                  if (this.$grid) {
                    this.$grid.$emit('state-change')
                  }
                  this.$nextTick(() => {
                    this.$emit('hidePopoverAndRefresh')
                  })
                  break
                }
                default: {
                  this.$message.warning(response.data['message'])
                  break
                }
              }
            }
          }, () => {
            this.$message.error('请求发送失败，请稍后重试')
          }).finally(() => {
            this.committing = false
          })
        }).catch(err => {
          this.$message.warning(err.message)
        })
      }
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  },
  mounted () {
    this.loadAuditInfo()
  }
}
</script>

<style lang="scss">
  .status-change-roll-class-not-audit-final {
    min-height: 200px;
    & > .body {
      & > .audit-main {
        padding: 20px 30px;
        .el-form {
          .el-form-item {
            margin-bottom: 12px;
            &:last-child {
              margin-bottom: 0;
            }
            .el-form-item__label {
              font-size: 12px;
            }
            .el-form-item__content {
              font-size: 12px;
              .el-textarea {
                width: 100%;
              }
              .el-radio-group {
                .el-radio {
                  .el-radio__label {
                    font-size: 12px;
                  }
                }
              }
            }
          }
        }
      }
    }
    & > .footer {
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
    }
  }
</style>
